/*!
 * BaseView - Classe parente de base pour toutes les vues d'IconsView
 */

export default class BaseView {
    constructor(plugin, name) {
        this.plugin = plugin;
        this.name = name;
        this.container = null;
    }

    get element() {
        return this.plugin.element;
    }

    get options() {
        return this.plugin.options;
    }

    get template() {
        return this.plugin.template;
    }

    /**
     * Crée et attache l'élément conteneur pour cette vue.
     * @param {jQuery} element - L'élément cible où insérer le conteneur
     * @returns {jQuery}
     */
    createContainer(element) {
        this.container = $('<div></div>');
        this.plugin.container = this.container;
        this.plugin.containerView.addClass('iv__view iv__view--' + this.name + ' view view-' + this.name);
        element.append(this.container);
        if (this.plugin.preview) {
            element.append(this.plugin.preview);
        }
        return this.container;
    }

    /**
     * Hook appelé après la création du conteneur et avant le rendu des éléments.
     * @param {jQuery} element
     * @param {Object} node
     * @param {Boolean} subdir
     */
    postCreateContainer(element, node, subdir) {}

    /**
     * Rendu d'un élément selon cette vue.
     * @param {Object} data - Données de l'élément
     * @param {jQuery} container - Conteneur cible
     * @param {Boolean} subdir - Indicateur sous-répertoire
     * @param {Array} path - Chemin courant
     * @returns {jQuery|null}
     */
    renderIcon(data, container, subdir, path) {
        return null;
    }

    /**
     * Résout les types d'un élément sous forme de tableau.
     * @param {Object} data
     * @returns {Array<String>}
     */
    getTypes(data) {
        let currentType = (data && data.type) ? data.type : 'item';
        if (typeof currentType === 'string') currentType = [currentType];
        return currentType;
    }

    /**
     * Construit les classes CSS standard pour un élément.
     * @param {Object} data
     * @param {Array} currentType
     * @param {String} currentClass
     * @returns {String}
     */
    buildItemClasses(data, currentType, currentClass) {
        const myself = this.plugin;
        const currentRandomId = parseInt(Math.random() * 1000000, 10);
        const currentClassAll = [
            'iv__item',
            'iv__item--' + data.id,
            'iv__item--' + currentRandomId,
            'iv__item--' + data.type,
            'iv__item--' + myself.name + '-' + data.type,
            'item',
            'item-' + data.type,
            'item-' + myself.name + '-' + data.type,
            currentClass
        ];

        $.each(currentType, function () {
            currentClassAll.push('iv__item--type-' + this);
        });

        if (data.ref) currentClassAll.push('iv__item--ref-' + data.ref);
        if (data.special) currentClassAll.push('iv__item--special-' + data.special);

        // Test de sélection
        $.each(myself.selection, (selectionIndex, selectionItem) => {
            if (selectionItem.id == data.id && selectionItem.type == data.type) {
                currentClassAll.push('iv__item--selected');
            }
        });

        // Test droppable
        let enableDroppable = false;
        if (myself.options && myself.options.features && myself.options.features.droppable) {
            $.each(myself.options.features.droppable, function () {
                if (this.target.indexOf(data.type) > -1) {
                    enableDroppable = true;
                }
            });
        }
        if (!enableDroppable) currentClassAll.push('iv__item--nonesting');

        return currentClassAll.filter(Boolean).join(' ');
    }

    /**
     * Résout la forme (shape) configurée pour un élément dans cette vue.
     * @param {Object} data
     * @returns {String}
     */
    getItemShape(data) {
        if (typeof this.plugin.getItemShape === 'function') {
            return this.plugin.getItemShape(data, this.name);
        }
        return (data && (data.shape ?? (data.data && data.data.shape))) || 'default';
    }

    /**
     * Attache les événements et données communs à un élément rendu.
     * @param {jQuery} currentIcon
     * @param {jQuery} currentIconReact
     * @param {Object} data
     * @param {Array} currentType
     * @param {Array} path
     */
    attachItemEvents(currentIcon, currentIconReact, data, currentType, path) {
        const myself = this.plugin;
        if (!currentIconReact) currentIconReact = currentIcon;

        // Attachement des propriétés de données
        $.each(data, (propertie, value) => {
            if (typeof propertie === 'string') {
                currentIcon.data(propertie, value);
            }
        });
        currentIcon.data('type', currentType);
        currentIcon.data('plugin', myself);
        currentIcon.data('data', data);
        currentIcon.data('path', path);

        let iconClicksCount = 0;
        let iconClicksTimer = null;

        // Gestionnaire de clics (simple / double / modificateurs)
        currentIconReact.click(function (event) {
            let icon = $(this);
            if (!icon.hasClass('.iv__item')) {
                icon = icon.closest('.iv__item');
            }

            let haveDblClick = false;
            const dblClickEvent = (myself.options && myself.options.event) ? myself.options.event.doubleClick : null;
            if (dblClickEvent) {
                if (myself.listTrigger.indexOf(dblClickEvent) == -1) {
                    if (icon.data('actions') && icon.data('actions')[dblClickEvent]) {
                        haveDblClick = true;
                    }
                } else {
                    haveDblClick = true;
                }
            }

            let trigger = 'leftClick';
            if (event.ctrlKey || event.metaKey) trigger = 'ctrlClick';
            else if (event.altKey) trigger = 'altClick';
            else if (event.shiftKey) trigger = 'shiftClick';

            if (trigger != 'leftClick' || !haveDblClick || (trigger == 'leftClick' && myself.options.event && myself.options.event.leftClick == 'select1')) {
                myself.iconTrigger(icon, trigger);
            } else {
                iconClicksCount++;
                if (iconClicksCount === 1) {
                    iconClicksTimer = setTimeout(() => {
                        myself.iconTrigger(icon, trigger);
                        iconClicksCount = 0;
                    }, 200);
                } else {
                    clearTimeout(iconClicksTimer);
                    iconClicksCount = 0;
                }
            }
        });

        // Double-clic direct si configuré
        if (myself.options && myself.options.event && myself.options.event.doubleClick) {
            currentIconReact.dblclick(function () {
                let icon = $(this);
                if (!icon.hasClass('.iv__item')) {
                    icon = icon.closest('.iv__item');
                }
                myself.iconTrigger(icon, 'doubleClick');
            });
        }

        // Clic sur boutons d'action
        currentIcon.find('.iv__item__action button').click(function () {
            const button = $(this);
            const icon = button.closest('.iv__item');
            if (icon.data('actions')) {
                const currentAction = icon.data('actions')[button.data('action')];
                icon.data('plugin').action(currentAction, icon);
            }
        });

        // Clic droit (menu contextuel d'élément)
        currentIconReact.on('contextmenu', function () {
            let icon = $(this);
            if (!icon.hasClass('.iv__item')) {
                icon = icon.closest('.iv__item');
            }
            myself.iconTrigger(icon, 'rightClick');
            return false;
        });

        // Visualiseur média
        if (data.file) {
            currentIcon.append('<a class="iv__item__preview imgbox" href="' + data.file + '" rel="iv__slideshow--' + myself.name + '" data-fancybox="iv__slideshow--' + myself.name + '" caption="' + data.label + '" data-caption="' + data.label + '"></a>');
        }

        // Construction du menu contextuel d'actions
        if (data.actions) {
            const menuItems = [];
            $.each(data.actions, (propertie, value) => {
                if (!value) return true;
                let smallCurrentIcon = value.icon;
                if (typeof smallCurrentIcon === 'object') smallCurrentIcon = smallCurrentIcon.small;
                const menuItem = {
                    name: value.label,
                    icon: smallCurrentIcon,
                    callback(icon) {
                        const plugin = icon.data('plugin');
                        const grid = icon.closest('.iconGrid');
                        if (icon.hasClass('iv__item--selected') && grid.find('.iv__item--selected').length > 1) {
                            plugin.action(icon.data('actions')[propertie], grid, propertie);
                        } else {
                            plugin.action(icon.data('actions')[propertie], icon, propertie);
                        }
                    },
                };
                menuItems.push(menuItem);
            });
            if (menuItems.length) {
                currentIcon.data('menu', menuItems);
            }
        }
    }

    /**
     * Rendu et attachement des badges numériques ou d'état sur l'élément.
     * @param {Object} data
     * @param {jQuery} currentIcon
     */
    renderBadge(data, currentIcon) {
        const myself = this.plugin;
        if (!data) return;

        // Si badge est explicitement null ou false, pas de badge
        if (data.badge === null || data.badge === false) return;

        // Conversion automatique count -> badge si demandé
        // Si data.count est null (ou undefined), aucun badge de comptage n'est généré
        if (!data.badge && typeof myself.shouldShowCountBadge === 'function' && myself.shouldShowCountBadge(data) && data.count !== undefined && data.count !== null) {
            data.badge = {
                type: 'count',
                value: data.count,
            };
        }

        if (data.badge) {
            const badgeData = typeof data.badge === 'object' ? data.badge : { value: data.badge };

            // Si c'est un badge de type "count" et que count ou sa valeur est explicitement null, ne pas afficher
            if ((badgeData.type === 'count' || badgeData.count !== undefined) && (badgeData.value === null || data.count === null)) {
                return;
            }

            let badgeVal = badgeData.value;
            if (badgeVal === undefined && data.count !== undefined && data.count !== null) badgeVal = data.count;

            const badgeWrap = $('<div class="iv__item__badge__wrap"></div>');
            const badge = $('<div class="iv__item__badge"></div>');

            if (badgeData.class || badgeData.cls) {
                badge.addClass(badgeData.class || badgeData.cls);
            }

            if (badgeData.position) {
                badge.addClass('iv__item__badge--' + badgeData.position);
            }

            // Détermination intelligente de la forme du badge (shape)
            // Formes : 'circle' | 'rectangle' | 'pill' | 'square' | 'auto'
            let shape = (badgeData.shape || badgeData.form || badgeData.format || 'auto').toLowerCase();
            const isCount = (badgeData.type === 'count') || 
                            (badgeData.field !== undefined) || 
                            (data.count !== undefined && data.count !== null) || 
                            (badgeVal !== undefined && badgeVal !== null && badgeVal !== '' && !isNaN(Number(badgeVal))) ||
                            (typeof myself.shouldShowCountBadge === 'function' && myself.shouldShowCountBadge(data));

            // Mode AUTO :
            // - Pour tout ce qui est de count : forme rectangle qui s'allonge en fonction du nombre.
            // - Pour les icônes (check, times, icon) : circle.
            // - Pour le texte : rectangle (ou pill si demandé) dès 2 caractères, circle pour 1 caractère.
            if (shape === 'auto') {
                if (isCount) {
                    shape = 'rectangle';
                } else if (badgeData.icon || badgeData.type === 'check' || badgeData.type === 'times') {
                    shape = 'circle';
                } else {
                    const rawVal = (badgeVal !== undefined && badgeVal !== null) ? badgeVal : (badgeData.text !== undefined ? badgeData.text : '');
                    const charCount = String(rawVal).length;
                    if (badgeData.pill) {
                        shape = 'pill';
                    } else if (charCount >= 2) {
                        shape = 'rectangle';
                    } else {
                        shape = 'circle';
                    }
                }
            } else if (shape === 'rect') {
                shape = 'rectangle';
            } else if (shape === 'round') {
                shape = 'circle';
            }

            badge.addClass('iv__item__badge--shape-' + shape);
            if (shape === 'rectangle') badge.addClass('iv__item__badge--rectangle');
            else if (shape === 'pill') badge.addClass('iv__item__badge--pill');
            else if (shape === 'circle') badge.addClass('iv__item__badge--circle');
            else if (shape === 'square') badge.addClass('iv__item__badge--square');

            let badgeInput = null;
            const applyBadgeLength = (val) => {
                const str = String(val !== undefined && val !== null ? val : '');
                const len = Math.max(1, str.length);
                badge.removeClass('iv__item__badge--len-1 iv__item__badge--len-2 iv__item__badge--len-3 iv__item__badge--len-4 iv__item__badge--len-5');
                badge.addClass('iv__item__badge--len-' + Math.min(len, 5));
                badge.attr('data-len', len);
                if (shape === 'rectangle' || shape === 'pill') {
                    badge.css('--badge-char-len', len);
                    if (badgeInput && badgeInput.length) {
                        badgeInput.css('width', (len + 0.6) + 'ch');
                    }
                }
            };

            if (badgeData.size) {
                if (typeof badgeData.size === 'number') {
                    const pxSize = badgeData.size + 'px';
                    if (shape === 'rectangle' || shape === 'pill') {
                        badge.css({
                            height: pxSize,
                            minHeight: pxSize,
                            minWidth: pxSize,
                            width: 'auto'
                        });
                    } else {
                        badge.css({
                            width: pxSize,
                            height: pxSize,
                            minWidth: pxSize,
                            minHeight: pxSize
                        });
                    }
                } else if (['tiny', 'small', 'medium', 'large'].indexOf(badgeData.size) !== -1) {
                    badge.addClass('iv__item__badge--size-' + badgeData.size);
                } else {
                    if (shape === 'rectangle' || shape === 'pill') {
                        badge.css({
                            height: badgeData.size,
                            minHeight: badgeData.size,
                            minWidth: badgeData.size,
                            width: 'auto'
                        });
                    } else {
                        badge.css({
                            width: badgeData.size,
                            height: badgeData.size,
                            minWidth: badgeData.size,
                            minHeight: badgeData.size
                        });
                    }
                }
            }

            const badgeBg = badgeData.color || badgeData.bg || badgeData.backgroundColor;
            if (badgeBg) {
                badge.css('background-color', badgeBg);
            }
            const badgeFg = badgeData.textColor || badgeData.colorText;
            if (badgeFg) {
                badge.css('color', badgeFg);
            }

            if (badgeData.border === false || badgeData.border === 0 || badgeData.border === 'none') {
                badge.css('border', 'none');
            } else if (badgeData.borderColor) {
                badge.css('border-color', badgeData.borderColor);
            }

            const badgeTip = badgeData.title || badgeData.tooltip;
            if (badgeTip) {
                badge.attr('title', badgeTip);
            }

            if (badgeData.field) {
                badgeInput = $('<input class="iv__item__badge__input" type="number" min="0" value="' + (badgeVal !== undefined ? badgeVal : 0) + '" />');
                applyBadgeLength(badgeVal !== undefined ? badgeVal : 0);
                badgeInput.on('input change', function () {
                    applyBadgeLength($(this).val());
                });

                const fSizeInput = badgeData.fontSize || badgeData.textSize;
                if (fSizeInput) {
                    if (typeof fSizeInput === 'number') {
                        badge.css('--badge-font-size', fSizeInput + 'px');
                    } else if (['small', 'medium', 'large'].indexOf(fSizeInput) !== -1) {
                        badge.addClass('iv__item__badge--font-' + fSizeInput);
                    } else {
                        badge.css('--badge-font-size', fSizeInput);
                    }
                }
                badgeWrap.append(badgeInput);
                badge.append(badgeWrap);
                if (this.name === 'table' && currentIcon.find('.iv__item__table-badge').length) {
                    currentIcon.find('.iv__item__table-badge').append(badge);
                } else {
                    currentIcon.find('.iv__item__image').append(badge);
                }

                if (typeof myself.applyQteClass === 'function') {
                    myself.applyQteClass(currentIcon);
                }

                badgeInput.change(function () {
                    const field = badgeData.field;
                    const queryData = {};
                    queryData[field] = $(this).val();
                    myself.submitChange(data, queryData);
                    if (typeof myself.applyQteClass === 'function') {
                        myself.applyQteClass(currentIcon);
                    }
                });

                badge.click(function (event) {
                    const spinnedInput = $(this).find('input');
                    spinnedInput.focus();
                    spinnedInput.select();
                    event.preventDefault();
                    event.stopPropagation();
                });

                badge.bind('touchstart mousedown', function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    if (event.type === 'touchstart') {
                        event = event.originalEvent.targetTouches[0];
                    }

                    myself.lockActions = true;

                    const spinnedInput = $(this).find('input');
                    const spinnedInputVal = $(this).find('.input-spinable-val');

                    spinnedInput.closest('.iv__item').addClass('iv__item--dragbadge');
                    spinnedInput.data('mouseY', event.pageY);
                    spinnedInput.data('value', spinnedInput.val());
                    spinnedInput.data('original', spinnedInput.val());

                    $(document).bind('touchmove mousemove', (moveEvt) => {
                        let e = moveEvt;
                        if (e.type === 'touchmove') {
                            e = e.originalEvent.changedTouches[0];
                        }

                        const pxToChangeValue = 20;
                        const increment = parseInt((spinnedInput.data('mouseY') - e.pageY) / pxToChangeValue, 10);
                        const newVal = parseInt(spinnedInput.data('value'), 10) + increment;
                        spinnedInput.val(newVal);
                        if (spinnedInput.attr('min') && newVal < spinnedInput.attr('min')) {
                            spinnedInput.val(spinnedInput.attr('min'));
                        }
                        if (spinnedInput.attr('max') && newVal > spinnedInput.attr('max')) {
                            spinnedInput.val(spinnedInput.attr('max'));
                        }
                        applyBadgeLength(spinnedInput.val());
                        if (increment !== 0) {
                            spinnedInput.blur();
                        }
                        if (typeof myself.applyQteClass === 'function') {
                            myself.applyQteClass(currentIcon);
                        }

                        if (typeof numberWithSpaces === 'function') {
                            spinnedInputVal.text(numberWithSpaces(spinnedInput.val()));
                        }
                    });

                    $(document).bind('touchend mouseup', () => {
                        setTimeout(() => {
                            myself.lockActions = false;
                        }, 50);
                        if (spinnedInput) {
                            applyBadgeLength(spinnedInput.val());
                            if (spinnedInput.data('original') != spinnedInput.val()) {
                                spinnedInput.change();
                            }
                            spinnedInput.closest('.iv__item').removeClass('iv__item--dragbadge');
                            $(document).unbind('touchmove mousemove');
                        }
                    });
                });
            } else {
                badge.addClass('iv__item__badge--static');
                if (badgeVal !== undefined) {
                    badge.attr('data-val', badgeVal);
                }

                let badgeContent;
                let hasIcon = false;

                if (badgeData.type === 'check') {
                    badgeContent = $('<i class="fa fa-check"></i>');
                    hasIcon = true;
                } else if (badgeData.type === 'times') {
                    badgeContent = $('<i class="fa fa-times"></i>');
                    hasIcon = true;
                } else if (badgeData.icon) {
                    const iconSizeParam = (badgeData.iconSize === 'small' || badgeData.iconSize === 'medium' || badgeData.iconSize === 'large')
                        ? badgeData.iconSize
                        : 'small';
                    badgeContent = $(myself.renderIconImage(iconSizeParam, badgeData.icon));
                    hasIcon = true;
                } else {
                    const rawText = (badgeVal !== undefined && badgeVal !== null) ? badgeVal : (badgeData.text !== undefined ? badgeData.text : '');
                    const textStr = String(rawText);
                    badgeContent = $('<span class="iv__item__badge__val">' + textStr + '</span>');
                    applyBadgeLength(textStr);
                }

                if (hasIcon) {
                    badge.addClass('iv__item__badge--has-icon');
                    if (badgeData.iconSize) {
                        if (typeof badgeData.iconSize === 'number') {
                            badge.css('--badge-icon-size', badgeData.iconSize + 'px');
                            badge.css('--badge-icon-max', badgeData.iconSize + 'px');
                        } else if (['small', 'medium', 'large'].indexOf(badgeData.iconSize) !== -1) {
                            badge.addClass('iv__item__badge--icon-' + badgeData.iconSize);
                        } else {
                            badge.css('--badge-icon-size', badgeData.iconSize);
                            if (String(badgeData.iconSize).indexOf('%') !== -1) {
                                badge.css('--badge-icon-max', badgeData.iconSize);
                            }
                        }
                    }
                } else {
                    badge.addClass('iv__item__badge--has-text');
                    const fSizeOpt = badgeData.fontSize || badgeData.textSize;
                    if (fSizeOpt) {
                        if (typeof fSizeOpt === 'number') {
                            badge.css('--badge-font-size', fSizeOpt + 'px');
                        } else if (['small', 'medium', 'large'].indexOf(fSizeOpt) !== -1) {
                            badge.addClass('iv__item__badge--font-' + fSizeOpt);
                        } else {
                            badge.css('--badge-font-size', fSizeOpt);
                        }
                    }
                }

                badgeWrap.append(badgeContent);
                badge.append(badgeWrap);
                if (this.name === 'table' && currentIcon.find('.iv__item__table-badge').length) {
                    currentIcon.find('.iv__item__table-badge').append(badge);
                } else {
                    currentIcon.find('.iv__item__image').append(badge);
                }

                if (!hasIcon && badgeVal !== undefined && badgeVal !== '' && !isNaN(parseInt(badgeVal, 10)) && (badgeData.type === 'count' || (typeof myself.shouldShowCountBadge === 'function' && myself.shouldShowCountBadge(data)))) {
                    if (typeof myself.applyQteClass === 'function') {
                        myself.applyQteClass(currentIcon);
                    }
                }
            }
        }
    }

    /**
     * Limites et activation du zoom pour la barre d'outils
     * @returns {{ enabled: boolean, min: number, max: number }}
     */
    getZoomLimits() {
        return {
            enabled: false,
            min: 16,
            max: 256,
        };
    }

    /**
     * Hook de redimensionnement spécifique à la vue
     */
    resize() {}

    /**
     * Hook de destruction et nettoyage
     */
    destroy() {}
}
